{
	"actions": {
		"ban": "Ban user",
		"delete": "Delete account",
		"open_menu": "Open actions menu",
		"unban": "Unban user",
		"view_detail": "View details"
	},
	"ban_user": {
		"cancel": "Cancel",
		"confirm": "Ban user",
		"description": "Ban {{email}} and revoke all active sessions. Add an expiry date to make the ban temporary.",
		"expires_at": "Ban until",
		"expires_at_placeholder": "Pick a date",
		"reason": "Reason",
		"reason_placeholder": "Optional reason",
		"success": "User banned.",
		"title": "Ban user"
	},
	"columns": {
		"actions": "Actions",
		"ban_expires": "Banned until",
		"ban_permanent": "Permanent ban",
		"ban_reason": "Ban reason",
		"ban_temporary": "Temporary ban",
		"email_verified": "Email verified",
		"no_ban_reason": "No reason",
		"signup_source": "Signup source",
		"status": "Status"
	},
	"delete_user": {
		"cancel": "Cancel",
		"confirm": "Delete account",
		"description": "Permanently close {{email}}. The user can no longer sign in, all active sessions end immediately, and the email is freed for reuse. This cannot be undone.",
		"reason": "Reason",
		"reason_placeholder": "Why is this account being deleted?",
		"request_reference": "Request reference (optional)",
		"request_reference_placeholder": "Support ticket or data-request id",
		"success": "Account deleted.",
		"title": "Delete account",
		"validation": {
			"reason_required": "A reason is required.",
			"reason_too_long": "The reason must be at most 500 characters.",
			"reference_too_long": "The reference must be at most 200 characters."
		}
	},
	"detail": {
		"account": {
			"title": "Account"
		},
		"breadcrumb": "User detail",
		"sessions": {
			"columns": {
				"device": "Device",
				"expires_at": "Expires",
				"last_activity": "Last activity",
				"location": "Location",
				"source": "Created via",
				"status": "Status"
			},
			"empty": "No sessions found.",
			"source": {
				"email_otp": "Email OTP"
			},
			"status": {
				"active": "Active",
				"expired": "Expired",
				"revoked": "Revoked"
			},
			"title": "Sessions",
			"unknown_device": "Unknown device"
		},
		"unknown_user": "User",
		"user_id": "User ID"
	},
	"filters": {
		"field": {
			"created_at": "Created at",
			"status": "Status",
			"verified": "Email verified"
		}
	},
	"page_title": "Users",
	"release_tax_code": {
		"confirm": "Free the tax code",
		"description": "For a student who cannot save their own tax code because another profile holds it. Free it only after seeing the person's identity document. The profile that held it goes back to incomplete and the operation stays in the log.",
		"open": "Free a tax code",
		"reason": "Reference of the check",
		"reason_placeholder": "Optional, no personal data",
		"success": "Tax code freed.",
		"tax_code": "Tax code",
		"title": "Free a tax code"
	},
	"search_placeholder": "Search user...",
	"signup_source": {
		"email": "Email"
	},
	"unban_user": {
		"cancel": "Cancel",
		"confirm": "Unban user",
		"description": "Lift the ban for {{email}}.",
		"success": "User unbanned.",
		"title": "Unban user"
	}
}
